/**
 * @param {string[]} fileTypes list of file type extensions (pdf,png,jpg,...)
 * @returns {string} the fileTypes list as a string with '.' before each extension
 */
export const convertAcceptedFileTypes = (fileTypes = []) =>
  fileTypes
    ?.sort()
    ?.map((type) => `.${type}`)
    ?.join(', ');

/**
 * @param {string} fileName the fileName to check (selfie.png, resume.pdf)
 * @param {string[]} allFileTypes list of all the supported file types to compare to
 * @returns {boolean} if the file type is included in the file types array
 */
export const getIsValidFileType = (fileName = '', allFileTypes = []) => {
  const splitName = fileName?.split('.');
  const ext = splitName?.[splitName?.length - 1];
  return allFileTypes?.includes(ext.toLowerCase());
};

/**
 * @param {string[]} acceptedTypes list of accepted file extensions (pdf,jpg,jpeg)
 * @param {Object[]} allTypes list of all possible file types
 * @returns {string} comma separated string of the file type labels (PDF, JPG)
 */
export const getFileTypeLabels = (acceptedTypes = [], allTypes = []) =>
  allTypes
    ?.filter((type) => type?.extensions?.some((ext) => acceptedTypes.includes(ext)))
    .map((type) => type?.label)
    .join(', ');



// WEBPACK FOOTER //
// ./src/utils/fileTypes.js